module.exports = __webpack_public_path__ + "static/img/yangjinmei.3714361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/yangjinmei.jpg
// module id = x/jx
// module chunks = 1